import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import NotificationsViewStore from './NotificationsViewStore';
var MultiWorkspaceNotificationStore = /*#__PURE__*/function () {
  function MultiWorkspaceNotificationStore(opts) {
    _classCallCheck(this, MultiWorkspaceNotificationStore);
    this.notificationViewStores = new Map();
    this.opts = opts;
  }
  return _createClass(MultiWorkspaceNotificationStore, [{
    key: "forWorkspace",
    value: function forWorkspace(workspaceId) {
      if (!this.notificationViewStores.has(workspaceId)) {
        this.notificationViewStores.set(workspaceId, new NotificationsViewStore(this.opts.rootStore.workspaceStore.workspaces.find(function (x) {
          return x.id === workspaceId;
        }), this.opts.rootStore));
      }
      return this.notificationViewStores.get(workspaceId);
    }
  }]);
}();
export { MultiWorkspaceNotificationStore as default };
//# sourceMappingURL=MultiWorkspaceNotificationStore.js.map
